/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import { GetBalanceState200ResponsePredictedDailyBalanceTransitionListInnerActivitiesInnerAppliedBy } from './get-balance-state200-response-predicted-daily-balance-transition-list-inner-activities-inner-applied-by';

/**
 * 
 * @export
 * @interface GetBalanceState200ResponsePredictedDailyBalanceTransitionListInnerActivitiesInner
 */
export interface GetBalanceState200ResponsePredictedDailyBalanceTransitionListInnerActivitiesInner {
    /**
     * 
     * @type {string}
     * @memberof GetBalanceState200ResponsePredictedDailyBalanceTransitionListInnerActivitiesInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetBalanceState200ResponsePredictedDailyBalanceTransitionListInnerActivitiesInner
     */
    'organizationId': string;
    /**
     * 
     * @type {string}
     * @memberof GetBalanceState200ResponsePredictedDailyBalanceTransitionListInnerActivitiesInner
     */
    'organizationName': string;
    /**
     * 
     * @type {string}
     * @memberof GetBalanceState200ResponsePredictedDailyBalanceTransitionListInnerActivitiesInner
     */
    'type': GetBalanceState200ResponsePredictedDailyBalanceTransitionListInnerActivitiesInnerTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetBalanceState200ResponsePredictedDailyBalanceTransitionListInnerActivitiesInner
     */
    'status': GetBalanceState200ResponsePredictedDailyBalanceTransitionListInnerActivitiesInnerStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof GetBalanceState200ResponsePredictedDailyBalanceTransitionListInnerActivitiesInner
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof GetBalanceState200ResponsePredictedDailyBalanceTransitionListInnerActivitiesInner
     */
    'supplierName': string;
    /**
     * 
     * @type {number}
     * @memberof GetBalanceState200ResponsePredictedDailyBalanceTransitionListInnerActivitiesInner
     */
    'amount': number;
    /**
     * 
     * @type {number}
     * @memberof GetBalanceState200ResponsePredictedDailyBalanceTransitionListInnerActivitiesInner
     */
    'pointAmount': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetBalanceState200ResponsePredictedDailyBalanceTransitionListInnerActivitiesInner
     */
    'balance': number | null;
    /**
     * 
     * @type {number}
     * @memberof GetBalanceState200ResponsePredictedDailyBalanceTransitionListInnerActivitiesInner
     */
    'pointBalance': number | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetBalanceState200ResponsePredictedDailyBalanceTransitionListInnerActivitiesInner
     */
    'isConfirmed': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetBalanceState200ResponsePredictedDailyBalanceTransitionListInnerActivitiesInner
     */
    'appliedAt': string | null;
    /**
     * 
     * @type {GetBalanceState200ResponsePredictedDailyBalanceTransitionListInnerActivitiesInnerAppliedBy}
     * @memberof GetBalanceState200ResponsePredictedDailyBalanceTransitionListInnerActivitiesInner
     */
    'appliedBy': GetBalanceState200ResponsePredictedDailyBalanceTransitionListInnerActivitiesInnerAppliedBy;
    /**
     * 
     * @type {string}
     * @memberof GetBalanceState200ResponsePredictedDailyBalanceTransitionListInnerActivitiesInner
     */
    'executedAt': string | null;
}

export const GetBalanceState200ResponsePredictedDailyBalanceTransitionListInnerActivitiesInnerTypeEnum = {
    payBill: 'PAY_BILL',
    deposit: 'DEPOSIT',
    withdrawal: 'WITHDRAWAL',
    reward: 'REWARD',
    usageFee: 'USAGE_FEE',
    point: 'POINT',
    cardPoint: 'CARD_POINT',
    campaignPoint: 'CAMPAIGN_POINT',
    card: 'CARD',
    depositFromGuaranteeMoney: 'DEPOSIT_FROM_GUARANTEE_MONEY',
    withdrawalToGuaranteeMoney: 'WITHDRAWAL_TO_GUARANTEE_MONEY',
    serviceCharge: 'SERVICE_CHARGE'
} as const;

export type GetBalanceState200ResponsePredictedDailyBalanceTransitionListInnerActivitiesInnerTypeEnum = typeof GetBalanceState200ResponsePredictedDailyBalanceTransitionListInnerActivitiesInnerTypeEnum[keyof typeof GetBalanceState200ResponsePredictedDailyBalanceTransitionListInnerActivitiesInnerTypeEnum];
export const GetBalanceState200ResponsePredictedDailyBalanceTransitionListInnerActivitiesInnerStatusEnum = {
    reserved: 'RESERVED',
    requestingExternalAccountTransfer: 'REQUESTING_EXTERNAL_ACCOUNT_TRANSFER',
    completed: 'COMPLETED',
    insufficientBalance: 'INSUFFICIENT_BALANCE',
    uploaded: 'UPLOADED',
    readCompleted: 'READ_COMPLETED',
    awaitingApproval: 'AWAITING_APPROVAL',
    approved: 'APPROVED',
    transferCompleted: 'TRANSFER_COMPLETED',
    readError: 'READ_ERROR',
    transferFailed: 'TRANSFER_FAILED',
    approvalExpired: 'APPROVAL_EXPIRED',
    approvalRejected: 'APPROVAL_REJECTED',
    otherError: 'OTHER_ERROR',
    pending: 'PENDING'
} as const;

export type GetBalanceState200ResponsePredictedDailyBalanceTransitionListInnerActivitiesInnerStatusEnum = typeof GetBalanceState200ResponsePredictedDailyBalanceTransitionListInnerActivitiesInnerStatusEnum[keyof typeof GetBalanceState200ResponsePredictedDailyBalanceTransitionListInnerActivitiesInnerStatusEnum];


